import { Link } from 'react-router-dom'
import { useHomeDashboard } from '@/api/queries'
import { StatusChip } from '@/components/ui/status-chip'
import type { WidgetSpan } from '../Widget'
import { Widget } from '../Widget'

/**
 * Top customer movements (usage Δ / MRR) need a billing + usage warehouse
 * feed that isn't wired yet — so this renders an honest "not wired yet" gap
 * rather than fabricated tenant MRR rows (data-truth rule #2). Real tenant
 * data (no fabricated numbers) already lives in the Customers module.
 */
export function TenantsWidget({ span = 6 }: { span?: WidgetSpan }) {
  const { data } = useHomeDashboard()

  return (
    <Widget
      title="Top customer movements"
      badges={
        <StatusChip status="unknown" stale>
          not wired yet
        </StatusChip>
      }
      provenance={data?.provenance.tenants}
      span={span}
      footer={
        <Link to="/customers" className="font-semibold text-accent hover:underline">
          Open Customers module →
        </Link>
      }
    >
      <div className="py-4 text-[12.5px] text-ink-2">
        Usage-delta and MRR movement ranking needs a billing + usage warehouse feed that isn't wired yet — so this stays
        an honest, empty placeholder instead of fabricated MRR numbers. Real tenant registry + footprint data lives in the
        Customers module.
      </div>
    </Widget>
  )
}
